import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * A person coming back from an Accounts page of the family bar's profile menu (`?returned=accounts`,
 * which the bar adds to the way back) arrives on a new page, so their standing at Accounts is read again
 * by the arrival itself; the marker only leaves the address, so a reload or a shared link does not carry it.
 */
export function Returned() {
	const navigate = useNavigate();
	const { pathname, search, hash } = useLocation();
	const returned = new URLSearchParams(search).get('returned') === 'accounts';

	useEffect(() => {
		if (!returned) return;
		const address = new URLSearchParams(search);
		address.delete('returned');
		const rest = address.toString();
		navigate(`${pathname}${rest ? `?${rest}` : ''}${hash}`, { replace: true });
	}, [returned, pathname, search, hash, navigate]);

	return null;
}
